import { Component, OnInit, inject } from '@angular/core'
import { AuthService } from './auth/services/auth.service'
import { ThemeService } from './signed-in/services/theme.service'
import { RouterModule } from '@angular/router'
import { WebsocketService } from './shared/services/websocket.service'
import { StaleBuildService } from './shared/services/stale-build.service'
import { TourMatMenu } from 'ngx-ui-tour-md-menu'

@Component({
  selector: 'seiri-root',
  templateUrl: './app.component.html',
  imports: [RouterModule, TourMatMenu],
})
export class AppComponent implements OnInit {
  private authService = inject(AuthService)
  private themeService = inject(ThemeService)
  private wsService = inject(WebsocketService)
  private staleBuild = inject(StaleBuildService)

  isDarkMode = this.themeService.isDarkTheme.asReadonly()

  ngOnInit() {
    this.wsService.connect()
    this.authService.autoLogin()
    this.staleBuild.start()
  }
}
